<div class="filter-toolbar-container container" *ngIf="toolbarState">
  <div class="inner-container" fxLayout="row" fxLayoutGap="10px">

    <mtn-google-search-assembly [map]="map"></mtn-google-search-assembly>

    <mat-divider vertical="true" style="height: 40px;"></mat-divider>

    <mtn-map-layers-assembly [map]="map" [toolbarState]="toolbarState"></mtn-map-layers-assembly>

    <div class="store-filter-toolbar" fxLayout="row" fxLayoutGap="10px"  *ngIf="toolbarState.isStoreLayerEnabled">
      <mtn-sales-filters-assembly [map]="map" [toolbarState]="toolbarState"></mtn-sales-filters-assembly>
      <mtn-area-filters-assembly [map]="map" [toolbarState]="toolbarState"></mtn-area-filters-assembly>
      <mtn-banner-filter-assembly [map]="map" [toolbarState]="toolbarState"></mtn-banner-filter-assembly>
      <mtn-fit-filter-assembly [map]="map" [toolbarState]="toolbarState"></mtn-fit-filter-assembly>
      <mtn-status-filter-assembly [map]="map" [toolbarState]="toolbarState"></mtn-status-filter-assembly>
      <mtn-collection-filter-assembly [map]="map" [toolbarState]="toolbarState"></mtn-collection-filter-assembly>

      <!-- <mtn-map-toolbar-button icon="file-pdf"
                              [matTooltip]="'Export PDF' | translate"
                              (toolbarClick)="onExportPdf()">
      </mtn-map-toolbar-button> -->
    </div>

    <mtn-map-toolbar-button icon="times" color="red" iconColor="red"
                            [matTooltip]="'FILTER_TOOLBAR.CLEAR_ALL' | translate"
                            [disabled]="!toolbarState.filterCount"
                            mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                            [analyticsEventParameters]="{'target': 'map-clear-filters-button'}"
                            *ngIf="!!map.options.featureType" (toolbarClick)="clearAllFilters()">
    </mtn-map-toolbar-button>

    <div fxFlex></div>
    <button (click)="onExportPdf()" class="capture-btn" matTooltip="Screenshot of this map area" *ngIf="(hasInternalLicense || hasStandardLicense)">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">

        <!-- 🔲 Outer rectangle/path -->
        <path
          d="M6.00234 0.955551H4.1855C3.05492 0.955551 2.48963 0.955551 2.0578 1.17558C1.67796 1.36912 1.36913 1.67794 1.17559 2.05779C0.955566 2.48961 0.955566 3.0549 0.955566 4.18549V6.00233M6.00234 19.124H4.1855C3.05492 19.124 2.48963 19.124 2.0578 18.9039C1.67796 18.7104 1.36913 18.4016 1.17559 18.0217C0.955566 17.5899 0.955566 17.0246 0.955566 15.894V14.0772M19.124 6.00233V4.18549C19.124 3.0549 19.124 2.48961 18.9039 2.05779C18.7104 1.67794 18.4016 1.36912 18.0217 1.17558C17.5899 0.955551 17.0246 0.955551 15.894 0.955551H14.0772M19.124 14.0772V15.894C19.124 17.0246 19.124 17.5899 18.9039 18.0217C18.7104 18.4016 18.4016 18.7104 18.0217 18.9039C17.5899 19.124 17.0246 19.124 15.894 19.124H14.0772"
          stroke="white" stroke-width="1.91111" stroke-linecap="round" stroke-linejoin="round" />

        <!-- ⭐ Inner SVG icon placed inside the rectangle -->
        <svg x="4.5" y="4.5" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <g clip-path="url(#clip0_655_360)">
            <path
              d="M4.49202 8.98822L0.996582 10.9856V2.99604L4.49202 0.998642M4.49202 8.98822L7.98746 10.9856M4.49202 8.98822V0.998642M7.98746 10.9856L10.9836 8.98822V0.998642L7.98746 2.99604M7.98746 10.9856V2.99604M7.98746 2.99604L4.49202 0.998642"
              stroke="white" stroke-width="1.24222" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_655_360">
              <rect width="11.9844" height="11.9844" fill="white" />
            </clipPath>
          </defs>
        </svg>

      </svg>


      Capture
    </button>

    <div class="filters-dropdown-container">
      <button class="filters-button" [matMenuTriggerFor]="filtersMenu">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <mask id="mask0" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="19">
            <path d="M1.76343 3.27525C1.00992 2.43309 0.633162 2.01201 0.61895 1.65415C0.606605 1.34328 0.740199 1.04448 0.980108 0.846393C1.25628 0.618362 1.8213 0.618362 2.95135 0.618362H17.7387C18.8688 0.618362 19.4338 0.618362 19.71 0.846393C19.9499 1.04448 20.0835 1.34328 20.0711 1.65415C20.0569 2.01201 19.6802 2.43309 18.9266 3.27525L13.2418 9.62894C13.0916 9.79681 13.0165 9.88075 12.9629 9.97628C12.9154 10.061 12.8806 10.1522 12.8595 10.247C12.8357 10.3539 12.8357 10.4666 12.8357 10.6918V16.0189C12.8357 16.2137 12.8357 16.3111 12.8043 16.3953C12.7765 16.4698 12.7313 16.5365 12.6725 16.5899C12.606 16.6503 12.5156 16.6865 12.3347 16.7589L8.9474 18.1138C8.58123 18.2602 8.39815 18.3335 8.25117 18.3029C8.12265 18.2762 8.00986 18.1999 7.93733 18.0905C7.85439 17.9653 7.85439 17.7682 7.85439 17.3738V10.6918C7.85439 10.4666 7.85439 10.3539 7.8306 10.247C7.8095 10.1522 7.77466 10.061 7.72716 9.97628C7.67361 9.88075 7.59851 9.79681 7.4483 9.62894L1.76343 3.27525Z"
                  stroke="white" stroke-width="1.23673" stroke-linecap="round" stroke-linejoin="round"/>
          </mask>
          <g mask="url(#mask0)">
            <path d="M-1.9707 20.4635L8.81475 20.895L9.24617 9.24666L10.109 6.22674H21.7573V-1.10738H-1.9707V20.4635Z" fill="white"/>
          </g>
          <g transform="translate(12.5, 13)">
            <path d="M5.5 0H0.55" stroke="white" stroke-width="1.2" stroke-linecap="round"/>
            <path d="M5.5 3.2H0.55" stroke="white" stroke-width="1.2" stroke-linecap="round"/>
            <path d="M5.5 6.4H0.55" stroke="white" stroke-width="1.2" stroke-linecap="round"/>
          </g>
        </svg>
        Filters
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none">
          <path d="M0.5 0.5L5 4.5L9.5 0.5" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <mat-menu #filtersMenu="matMenu" class="filters-menu-panel" [overlapTrigger]="false">
        <div class="filter-menu-header">
          <span class="filter-title">Filters</span>
          <div class="header-buttons">
            <button *ngIf="hasSelectedFilter() && savedSearches.length > 0" mat-icon-button class="clear-button" (click)="clearAllFilters()">
              Clear
            </button>
            <button mat-icon-button class="cancel-button" (click)="filtersMenu.closed.emit()">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M11.5929 2.15865C11.3814 1.94712 11.0384 1.94712 10.8269 2.15865L6.87579 6.10978L2.92468 2.15865C2.71315 1.94712 2.37018 1.94712 2.15865 2.15865C1.94712 2.37018 1.94712 2.71315 2.15865 2.92468L6.10976 6.87581L2.15866 10.8269C1.94713 11.0385 1.94713 11.3814 2.15866 11.593C2.3702 11.8045 2.71316 11.8045 2.92469 11.593L6.87579 7.64183L10.8269 11.593C11.0384 11.8045 11.3814 11.8045 11.5929 11.593C11.8045 11.3814 11.8045 11.0385 11.5929 10.8269L7.64181 6.87581L11.5929 2.92468C11.8045 2.71315 11.8045 2.37018 11.5929 2.15865Z" fill="#EAEAEA"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="divider-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="205" height="1" viewBox="0 0 205 1" fill="none">
            <path d="M0.5 0.5H204" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div *ngIf="savedSearches.length === 0" class="no-filters-message">
          No saved filters
        </div>
        <button mat-menu-item *ngFor="let option of savedSearches" (click)="selectSavedSearch(option)" [class.selected]="isSelectedFilter(option)">
          <div class="saved-search-item">
            <div class="tick-space">
              <svg *ngIf="isSelectedFilter(option)" class="tick-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3L4.5 8.5L2 6" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="saved-search-content">
              <div class="saved-search-name">{{option.name}}</div>
              <div class="saved-search-description" *ngIf="option.description">{{option.description}}</div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svsssg" width="18" height="18" class="delete-icon" [matTooltip]="'FILTER_TOOLBAR.DELETE' | translate"
                         matTooltipPosition="left" (click)="$event.stopPropagation(); openConfirmDeleteWizard(option)" viewBox="0 0 14 14" fill="none">
  <path d="M5.8335 6.41655V9.91655" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.1665 6.41655V9.91655" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.3335 4.08345H11.6668" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.5 4.08345H7H10.5V10.5001C10.5 11.4666 9.71652 12.2501 8.75 12.2501H5.25C4.2835 12.2501 3.5 11.4666 3.5 10.5001V4.08345Z" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.25 2.91667C5.25 2.27233 5.77233 1.75 6.41667 1.75H7.58333C8.22768 1.75 8.75 2.27233 8.75 2.91667V4.08333H5.25V2.91667Z" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
          </div>
        </button>
        <div class="divider-container">
          <svg xmlns="http://www.w3.org/2000/svg" width="205" height="1" viewBox="0 0 205 1" fill="none">
            <path d="M0.5 0.5H204" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <button *ngIf="hasSelectedFilter() && savedSearches.length > 0" class="update-filters" (click)="saveFilterGroupChanges()" [matTooltip]="'FILTER_TOOLBAR.SAVE_CHANGES' | translate" matTooltipPosition="left">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M3.57617 2.98015H9.53646C9.85261 2.98015 10.1558 3.10574 10.3794 3.32929C10.6029 3.55285 10.7285 3.85605 10.7285 4.17221V8.34441" stroke="white" stroke-width="1.19206" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.7285 11.3245H4.76823C4.45208 11.3245 4.14887 11.1989 3.92532 10.9754C3.70176 10.7518 3.57617 10.4486 3.57617 10.1325V5.96028" stroke="white" stroke-width="1.19206" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.94043 6.55632L10.7285 8.34441L12.5166 6.55632" stroke="white" stroke-width="1.19206" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.36426 7.74837L3.57617 5.96028L1.78809 7.74837" stroke="white" stroke-width="1.19206" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Update Current Filter
        </button>
        <button class="save-filters" (click)="openNewSavedSearchWizard()" [matTooltip]="'FILTER_TOOLBAR.SAVE_FILTERS' | translate">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M2.5 7.49988H12.5M7.5 2.49988V12.4999" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
         Save New Filter
        </button>
      </mat-menu>
    </div>
    <!-- <div class="saved-search-container container" [formGroup]="form">
      <mat-form-field class="default-field-width">
        <mat-select formControlName="savedSearch" [placeholder]="'FILTER_TOOLBAR.SAVED_SEARCH' | translate" #select>
          <mat-select-trigger>{{select.value?.name || ('FILTER_TOOLBAR.NONE' | translate)}}</mat-select-trigger>
          <mat-option class="color-muted" (onSelectionChange)="clearAllFilters()">
            {{ 'FILTER_TOOLBAR.NONE' | translate }}
          </mat-option>
          <mat-option *ngFor="let option of savedSearches" [value]="option"
                      mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.USE_SAVED_SEARCH"
                      (onSelectionChange)="handleSavedSearchSelected($event)">
            <div class="select-option" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                 style="line-height: 16px; max-width: 280px;">
              <div fxLayout="column" style="max-width: 244px">
                <small class="text-ellipsis">{{option.name}}</small>
                <small class="text-ellipsis color-muted">{{option.description}}</small>
              </div>
              <div fxFlex></div>
              <div class="container" mtnClickTrap [preventDefault]="false">
                <fa-icon class="clickable" icon="trash-alt"
                         [matTooltip]="'FILTER_TOOLBAR.DELETE' | translate"
                         matTooltipPosition="left"
                         (click)="openConfirmDeleteWizard(option)">
                </fa-icon>
              </div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mtn-spinner [size]="SpinnerSize.EXTRA_SMALL" [on]="!isSavedSearchesLoaded"></mtn-spinner>
    </div>

    <div class="container">
      <mtn-map-toolbar-button icon="save"
                              [matTooltip]="'FILTER_TOOLBAR.SAVE_CHANGES' | translate"
                              [disabled]="!form.get('savedSearch').value?.uuid || !isUnsavedChangesPresent"
                              mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                              [analyticsEventParameters]="{'target': 'update-saved-search'}"
                              (toolbarClick)="saveFilterGroupChanges()">
      </mtn-map-toolbar-button>
      <mtn-spinner [size]="SpinnerSize.EXTRA_SMALL" [on]="isSaving"></mtn-spinner>
    </div>

    <mtn-map-toolbar-button icon="save" [showEllipsis]="true"
                            [matTooltip]="'FILTER_TOOLBAR.SAVE_FILTERS' | translate"
                            mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                            [analyticsEventParameters]="{'target': 'create-saved-search'}"
                            (toolbarClick)="openNewSavedSearchWizard()">
    </mtn-map-toolbar-button>
  </div> -->
</div>


